// Module
var code = "<style>:host{display:block}#units{padding:0;margin:0;overflow:hidden;display:inline-block;text-overflow:ellipsis;white-space:nowrap;word-break:break-all;pointer-events:none}</style> <p id=\"units\"></p>";
// Exports
export default code;